import React, { useEffect, useState } from "react";
import { createSeparate, getDataItems } from "../../api/Separates";
import LoadingPage from "../Loading/loading";
import { useNavigate, useParams } from "react-router-dom";
import { Cookies } from "react-cookie";
import { ToastContainer, toast } from "react-toastify";
import {
  acceptResale,
  deleteResale,
  getItemForResale,
  getResale,
  resaleUpdate,
} from "../../api/Resale";

const ViewResaleComponent = (props) => {
  const params = useParams();
  const navigate = useNavigate();
  const cookie = new Cookies();
  const [loading, setLoading] = useState(false);
  const [deleteUnit, setDeleteUnit] = useState(false);
  const [acceptUnit, setAcceptUnit] = useState(false);
  const [resaleItems, setResaleItems] = useState(null);

  const [formData, setFormData] = useState(null);

  useEffect(() => {
    getResale(params.id).then((result) => {
      setFormData(result.data.response);
    });
  }, []);

  useEffect(() => {
    getItemForResale().then((result) => {
      setResaleItems(result.data);
    });
  }, []);

  const handleChange = (e) => {
    e.target.setCustomValidity("");
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    resaleUpdate(params.id, formData).then((result) => {
      if (result.data.message === "Resale is updated Successfully") {
        toast.success("Resale is created successfullly", {
          position: "top-right",
        });
        window.location.reload();
      }
      setLoading(false);
    });
  };

  const inputStyle = {
    position: "absolute",
    width: "1px",
    height: "1px",
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    border: 0,
  };

  const labelStyle = {
    display: "inline-block",
    padding: "10px 20px",
    backgroundColor: "#4CAF50",
    color: "white",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "500",
    transition: "background-color 0.3s",
    border: "none",
    textAlign: "center",
    ":hover": {
      backgroundColor: "#45a049",
    },
  };

  const labelDeleteStyle = {
    display: "inline-block",
    padding: "10px",
    backgroundColor: "red",
    color: "white",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "500",
    transition: "background-color 0.3s",
    border: "none",
    textAlign: "center",
    ":hover": {
      backgroundColor: "#45a049",
    },
    margin: "0px",
  };

  return (
    <div className="main-content">
      {formData === null || resaleItems === null ? (
        <LoadingPage />
      ) : (
        <div className="add-brokers-guideline">
          <form onSubmit={handleSubmit}>
            <label htmlFor="image">Images</label>
            <div className="image-previews">
              {formData.images.map((image, imageIndex) => (
                <div key={imageIndex} className="preview-item">
                  <img src={image} alt={`Preview ${imageIndex}`} />
                </div>
              ))}
            </div>

            <div className="form-group">
              <label htmlFor="adname">Title</label>
              <input
                type="text"
                id="adname"
                name="adname"
                value={formData.adname}
                onChange={handleChange}
                placeholder="Enter Title"
                required
                onInvalid={(e) =>
                  e.target.setCustomValidity("Title is required")
                }
              />
            </div>

            <div className="form-group">
              <label
                htmlFor="selltype"
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "500",
                }}
              >
                Sell type
              </label>
              <select
                className="form-select form-control form-select-lg border border-dark"
                aria-label="Select Sell type"
                name="selltype" // Changed from selltype to be more descriptive
                value={formData.selltype}
                onChange={(e) => {
                  e.target.setCustomValidity("");
                  setFormData({
                    ...formData,
                    selltype: e.target.value,
                  });
                }}
                style={{
                  width: "100%",
                  padding: "10px",
                  border: "1px solid #ddd",
                  borderRadius: "6px",
                  fontSize: "16px",
                  backgroundColor: "#fff",
                  cursor: "pointer",
                }}
                required
                onInvalid={(e) =>
                  e.target.setCustomValidity("Sell type is required")
                }
              >
                <option disabled value="">
                  Select Sell type
                </option>
                {resaleItems.selltypes?.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label
                htmlFor="type2"
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "500",
                }}
              >
                Type
              </label>
              <select
                className="form-select form-control form-select-lg border border-dark"
                aria-label="Select Type"
                name="type2" // Changed from type2 to be more descriptive
                value={formData.type2}
                onChange={(e) => {
                  e.target.setCustomValidity("");
                  setFormData({
                    ...formData,
                    type2: e.target.value,
                  });
                }}
                style={{
                  width: "100%",
                  padding: "10px",
                  border: "1px solid #ddd",
                  borderRadius: "6px",
                  fontSize: "16px",
                  backgroundColor: "#fff",
                  cursor: "pointer",
                }}
                required
                onInvalid={(e) =>
                  e.target.setCustomValidity("Type is required")
                }
              >
                <option disabled value="">
                  Select Type
                </option>
                {resaleItems.types?.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label
                htmlFor="finished"
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "500",
                }}
              >
                Finished
              </label>
              <select
                className="form-select form-control form-select-lg border border-dark"
                aria-label="Select Finished"
                name="finished" // Changed from finished to be more descriptive
                value={formData.finished}
                onChange={(e) => {
                  e.target.setCustomValidity("");
                  setFormData({
                    ...formData,
                    finished: e.target.value,
                  });
                }}
                style={{
                  width: "100%",
                  padding: "10px",
                  border: "1px solid #ddd",
                  borderRadius: "6px",
                  fontSize: "16px",
                  backgroundColor: "#fff",
                  cursor: "pointer",
                }}
                required
                onInvalid={(e) =>
                  e.target.setCustomValidity("Finished is required")
                }
              >
                <option disabled value="">
                  Select Finished
                </option>
                {resaleItems.finishing?.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label
                htmlFor="finished"
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "500",
                }}
              >
                Delivery
              </label>
              <select
                className="form-select form-control form-select-lg border border-dark"
                aria-label="Select Delivery"
                name="moveInDate" // Changed from finished to be more descriptive
                value={formData.moveInDate}
                onChange={(e) => {
                  e.target.setCustomValidity("");
                  setFormData({
                    ...formData,
                    moveInDate: e.target.value,
                  });
                }}
                style={{
                  width: "100%",
                  padding: "10px",
                  border: "1px solid #ddd",
                  borderRadius: "6px",
                  fontSize: "16px",
                  backgroundColor: "#fff",
                  cursor: "pointer",
                }}
                required
                onInvalid={(e) =>
                  e.target.setCustomValidity("Delivery is required")
                }
              >
                <option disabled value="">
                  Select Delivery
                </option>
                {resaleItems.delivery?.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>

            <div
              className="choices-container"
              style={{
                display: "flex",
                width: "100%",
                gap: "15px", // Better than space-between for consistent spacing
                flexWrap: "wrap",
              }}
            >
              <div className="form-group">
                <label
                  htmlFor="rooms"
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "500",
                  }}
                >
                  Rooms
                </label>
                <select
                  className="form-select form-control form-select-lg border border-dark"
                  aria-label="Select Rooms"
                  name="rooms" // Changed from rooms to be more descriptive
                  value={formData.rooms}
                  onChange={(e) => {
                    e.target.setCustomValidity("");
                    setFormData({
                      ...formData,
                      rooms: e.target.value,
                    });
                  }}
                  style={{
                    width: "100%",
                    padding: "10px",
                    border: "1px solid #ddd",
                    borderRadius: "6px",
                    fontSize: "16px",
                    backgroundColor: "#fff",
                    cursor: "pointer",
                  }}
                  required
                  onInvalid={(e) =>
                    e.target.setCustomValidity("Rooms is required")
                  }
                >
                  <option disabled value="">
                    Select Rooms
                  </option>
                  {resaleItems.rooms?.map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label
                  htmlFor="bathrooms"
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "500",
                  }}
                >
                  Bathrooms
                </label>
                <select
                  className="form-select form-control form-select-lg border border-dark"
                  aria-label="Select Bathrooms"
                  name="bathrooms" // Changed from bathrooms to be more descriptive
                  value={formData.bathrooms}
                  onChange={(e) => {
                    e.target.setCustomValidity("");
                    setFormData({
                      ...formData,
                      bathrooms: e.target.value,
                    });
                  }}
                  style={{
                    width: "100%",
                    padding: "10px",
                    border: "1px solid #ddd",
                    borderRadius: "6px",
                    fontSize: "16px",
                    backgroundColor: "#fff",
                    cursor: "pointer",
                  }}
                  required
                  onInvalid={(e) =>
                    e.target.setCustomValidity("Bathrooms is required")
                  }
                >
                  <option disabled value="">
                    Select Bathrooms
                  </option>
                  {resaleItems.bathrooms?.map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div
              className="choices-container"
              style={{
                display: "flex",
                width: "100%",
                gap: "15px", // Better than space-between for consistent spacing
                flexWrap: "wrap",
              }}
            >
              <div
                className="form-group"
                style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
              >
                <label htmlFor="price">Price</label>
                <input
                  type="number"
                  id="price"
                  name="price"
                  value={formData.price.value}
                  onChange={(e) => {
                    e.target.setCustomValidity("");
                    setFormData((prev) => ({
                      ...prev,
                      price: {
                        ...prev.price,
                        value: e.target.value,
                      },
                    }));
                  }}
                  placeholder="Enter Price"
                  required
                  onInvalid={(e) =>
                    e.target.setCustomValidity("Price is required")
                  }
                />
              </div>
              <div
                className="form-group"
                style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
              >
                <label htmlFor="size">Area</label>
                <input
                  type="number"
                  id="size"
                  name="size"
                  value={formData.size}
                  onChange={handleChange}
                  placeholder="Enter Area"
                  required
                  onInvalid={(e) =>
                    e.target.setCustomValidity("Area is required")
                  }
                />
              </div>
            </div>

            <div className="form-group">
              <label
                htmlFor="payment"
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "500",
                }}
              >
                Payment
              </label>
              <select
                className="form-select form-control form-select-lg border border-dark"
                aria-label="Select Payment"
                name="payment" // Changed from payment to be more descriptive
                value={formData.payment}
                onChange={(e) => {
                  e.target.setCustomValidity("");
                  setFormData({
                    ...formData,
                    payment: e.target.value,
                  });
                }}
                style={{
                  width: "100%",
                  padding: "10px",
                  border: "1px solid #ddd",
                  borderRadius: "6px",
                  fontSize: "16px",
                  backgroundColor: "#fff",
                  cursor: "pointer",
                }}
                required
                onInvalid={(e) =>
                  e.target.setCustomValidity("Payment is required")
                }
              >
                <option disabled value="">
                  Select Payment
                </option>
                {resaleItems.payment?.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>

            <div
              className="choices-container"
              style={{
                display: "flex",
                width: "100%",
                gap: "15px", // Better than space-between for consistent spacing
                flexWrap: "wrap",
              }}
            >
              <div
                className="form-group"
                style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
              >
                <label htmlFor="phone">Phone number</label>
                <input
                  type="text"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Enter Phone number"
                  maxLength="11"
                  pattern="^01[0-2,5]\d{1,8}$"
                  required
                  onInvalid={(e) =>
                    e.target.setCustomValidity("Phone is required")
                  }
                />
              </div>
              <div
                className="form-group"
                style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
              >
                <label htmlFor="whatsapp">Whatsapp</label>
                <input
                  type="text"
                  id="whatsapp"
                  name="whatsapp"
                  value={formData.whatsapp}
                  onChange={handleChange}
                  placeholder="Enter Whatsapp"
                  required
                  onInvalid={(e) =>
                    e.target.setCustomValidity("Whatsapp is required")
                  }
                />
              </div>
            </div>

            <div
              className="choices-container"
              style={{
                display: "flex",
                width: "100%",
                gap: "15px", // Better than space-between for consistent spacing
                flexWrap: "wrap",
              }}
            >
              <div
                className="form-group"
                style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
              >
                <label htmlFor="floor_level">Floor level</label>
                <input
                  type="number"
                  id="floor_level"
                  name="floor_level"
                  value={formData.floor_level}
                  onChange={handleChange}
                  placeholder="Enter Floor level"
                  pattern="^\d+(\.\d{1,10})?$"
                  required
                  onInvalid={(e) =>
                    e.target.setCustomValidity("Floor level is required")
                  }
                />
              </div>

              <div
                className="form-group"
                style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
              >
                <label htmlFor="upfront">Upfront</label>
                <input
                  type="number"
                  id="upfront"
                  name="upfront"
                  value={formData.upfront}
                  onChange={handleChange}
                  placeholder="Enter Upfront"
                  pattern="^\d+(\.\d{1,10})?$"
                  required
                  onInvalid={(e) =>
                    e.target.setCustomValidity("Upfront is required")
                  }
                />
              </div>
            </div>

            <div
              className="choices-container"
              style={{
                display: "flex",
                width: "100%",
                gap: "15px", // Better than space-between for consistent spacing
                flexWrap: "wrap",
              }}
            >
              <div className="form-group">
                <label
                  htmlFor="location"
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "500",
                  }}
                >
                  Location
                </label>
                <select
                  className="form-select form-control form-select-lg border border-dark"
                  aria-label="Select Location"
                  name="location" // Changed from location to be more descriptive
                  value={formData.location}
                  onChange={(e) => {
                    e.target.setCustomValidity("");
                    setFormData({
                      ...formData,
                      location: e.target.value,
                    });
                  }}
                  style={{
                    width: "100%",
                    padding: "10px",
                    border: "1px solid #ddd",
                    borderRadius: "6px",
                    fontSize: "16px",
                    backgroundColor: "#fff",
                    cursor: "pointer",
                  }}
                  required
                  onInvalid={(e) =>
                    e.target.setCustomValidity("Location is required")
                  }
                >
                  <option disabled value="">
                    Select Location
                  </option>
                  {resaleItems.locations?.map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </div>

              <div
                className="form-group"
                style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
              >
                <label htmlFor="unitCode">Unit code</label>
                <input
                  type="text"
                  id="unitCode"
                  name="unitCode"
                  value={formData.unitCode}
                  onChange={handleChange}
                  placeholder="Enter Unit code"
                  required
                  onInvalid={(e) =>
                    e.target.setCustomValidity("Unit code is required")
                  }
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="description">Description</label>
              <textarea
                type="text"
                id="description"
                name="description"
                value={formData.description}
                onChange={handleChange}
                placeholder="Enter description"
                required
                onInvalid={(e) =>
                  e.target.setCustomValidity("Description is required")
                }
              />
            </div>

            <div>
              <input
                type="checkbox"
                checked={formData.owner}
                onChange={() => {}}
                className="client-checkbox"
                disabled
              />
              <label htmlFor="owner" style={{ paddingLeft: "10px" }}>
                Owner
              </label>
            </div>

            <div
              onClick={() =>
                setFormData((prev) => ({
                  ...prev,
                  furnished: !prev.furnished,
                }))
              }
            >
              <input
                type="checkbox"
                checked={formData.furnished}
                onChange={() => {}}
                className="client-checkbox"
              />
              <label htmlFor="furnished" style={{ paddingLeft: "10px" }}>
                Furnished
              </label>
            </div>

            <div
              onClick={() =>
                setFormData((prev) => ({
                  ...prev,
                  price: {
                    ...prev.price,
                    negotiable: !prev.price.negotiable,
                  },
                }))
              }
            >
              <input
                type="checkbox"
                checked={formData.price.negotiable}
                onChange={() => {}}
                className="client-checkbox"
              />
              <label htmlFor="negotiable" style={{ paddingLeft: "10px" }}>
                Price Negotiable
              </label>
            </div>

            <div className="features-section">
              {resaleItems.additionals?.map((item, index) => {
                const isSelected = formData.additionals.some(
                  (additional) => additional === item,
                );

                return (
                  <div
                    className={`${
                      isSelected ? "features-item-selected" : "features-item"
                    }`}
                    key={index}
                    onClick={() => {
                      setFormData((prev) => {
                        const isSelected = prev.additionals.includes(item);

                        return {
                          ...prev,
                          additionals: isSelected
                            ? prev.additionals.filter((name) => name !== item)
                            : [...prev.additionals, item],
                        };
                      });
                    }}
                  >
                    <span className={`${isSelected ? "" : "label"}`}>
                      {item}
                    </span>
                  </div>
                );
              })}
            </div>

            {loading ? (
              <div
                style={{
                  width: "100%",
                  justifyContent: "center",
                  display: "flex",
                }}
              >
                <div className="spinner"></div>
              </div>
            ) : (
              <>
                {deleteUnit ? (
                  <div
                    style={{
                      border: "1px solid #ddd",
                      borderRadius: "4px",
                      padding: "5px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <p className="line">
                      Are you sure you want to delete this resale?{" "}
                    </p>
                    <div className="card-info">
                      <div className="card-actions">
                        <button
                          onClick={() => {
                            setDeleteUnit(false);
                          }}
                          className="action-btn accept-btn"
                        >
                          No
                        </button>
                      </div>
                      <div className="card-actions">
                        <button
                          onClick={() => {
                            setLoading(true);
                            deleteResale(params.id).then((resullt) => {
                              navigate(-1);
                            });
                          }}
                          className="action-btn remove-btn"
                        >
                          Yes
                        </button>
                      </div>
                    </div>
                  </div>
                ) : acceptUnit ? (
                  <div
                    style={{
                      border: "1px solid #ddd",
                      borderRadius: "4px",
                      padding: "5px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <p className="line">
                      Are you sure you want to accept this resale?{" "}
                    </p>
                    <div className="card-info">
                      <div className="card-actions">
                        <button
                          onClick={() => {
                            setAcceptUnit(false);
                          }}
                          className="action-btn accept-btn"
                        >
                          No
                        </button>
                      </div>
                      <div className="card-actions">
                        <button
                          onClick={() => {
                            setLoading(true);
                            acceptResale(params.id).then((resullt) => {
                              window.location.reload();
                            });
                          }}
                          className="action-btn remove-btn"
                        >
                          Yes
                        </button>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div
                    className="choices-container"
                    style={{
                      display: "flex",
                      width: "100%",
                      gap: "15px", // Better than space-between for consistent spacing
                      flexWrap: "wrap",
                      justifyContent: "center",
                    }}
                  >
                    <button
                      onClick={() => {
                        setDeleteUnit(true);
                      }}
                      className="action-btn remove-btn"
                      style={{ width: "45%" }}
                    >
                      Delete resale
                    </button>

                    {formData.pending === true ? (
                      <button
                        onClick={() => {
                          setAcceptUnit(true);
                        }}
                        className={`action-btn accept-btn`}
                        style={{ width: "45%" }}
                      >
                        Accept Resale
                      </button>
                    ) : (
                      <button
                        type="submit"
                        className="action-btn accept-btn"
                        style={{ width: "45%" }}
                      >
                        Update
                      </button>
                    )}
                  </div>
                )}
              </>
            )}
          </form>
          <ToastContainer />
        </div>
      )}
    </div>
  );
};

export default ViewResaleComponent;
